let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fIIu4")).then(() => parcelRequire('dQfKp'));